import CustomerListView from "@/views/admin/customers/CustomerListView";
import CustomerDetailView from "@/views/admin/customers/CustomerDetailView";

const meta = { middleware: ["auth"], roles: ["admin", "super_admin"] };

export default [
    {
        name: "admin.customers",
        path: "customers",
        component: CustomerListView,
        meta,
    },
    {
        name: "admin.customers.show",
        path: "customers/:id",
        component: CustomerDetailView,
        meta,
    },
];
